export default {
  background_image: 'Taustakuva',
};
